import http from "./httpService";

const apiEndPoint = "/buttonstype/";

function getButtonsTypes() {
  return http.get(apiEndPoint);
}

export default getButtonsTypes;
